import styled from '@emotion/styled';
import { List } from '@material-ui/core';

const TopicList = styled(List)({
  maxHeight: 540,
  overflowY: 'auto'
});

export default TopicList;
